import { createFileRoute } from "@tanstack/react-router";
import { MigrationTab } from "./settings.catalog";

export const Route = createFileRoute("/settings/catalog/migration")({
	component: MigrationTab,
});
